import React, { Fragment, useMemo } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { LoadingMoreSpinner } from './SmallUIComponents';
import ErrorBoundary from 'src/scripts/utils/react/ErrorBoundary';
import { PlpTile } from './PlpTiles';
import { ProductNode } from '../types';
import { checkIfCustomer } from 'src/scripts/utils/helpers';
import NoProductsMatchFilters from '../../search-page/components/NoProductsMatchFilters';

const BrowseListContainer = ({
  products,
  onScrollToEnd,
  isLoading,
  totalProducts,
  clearAllFilters,
  collectionHandle,
  collectionShopifyId,
  source,
  isPlp = false,
  merchant = '',
  hasNextPage,
}: BrowseListContainerOptions) => {
  const showLoadingSpinner = hasNextPage || isLoading;

  const onLoadMore = () => {
    if (!isLoading && hasNextPage) {
      onScrollToEnd();
    }
  };

  const [infiniteRef] = useInfiniteScroll({
    hasNextPage,
    loading: isLoading,
    onLoadMore,
    // Plptile min-height
    rootMargin: '0px 0px 520px 0px',
  });

  const isCustomer = useMemo(() => {
    return checkIfCustomer();
  }, []);

  const isWishlist = useMemo(() => {
    const url = window.location.href;
    return url.includes('view=wishlist');
  }, []);

  return (
    <>
      {totalProducts > 0 ? (
        <div className={`search-page-plp product-cards`}>
          <Fragment>
            {products.map((product, index) => {
              return (
                <ErrorBoundary key={product.id}>
                  <PlpTile
                    productData={product}
                    key={product.id}
                    index={index}
                    isCustomer={isCustomer}
                    isWishlist={isWishlist}
                    collectionHandle={collectionHandle}
                    collectionShopifyId={collectionShopifyId}
                    hasAFilterSelected={false}
                    source={source}
                    merchant={merchant}
                  />
                </ErrorBoundary>
              );
            })}
            {hasNextPage && <div ref={infiniteRef} />}
          </Fragment>
        </div>
      ) : (
        !isLoading && !isPlp && <NoProductsMatchFilters clearAllFilters={clearAllFilters} />
      )}
      {showLoadingSpinner && <LoadingMoreSpinner isVisible className={!isLoading ? 'delayed' : ''} />}
    </>
  );
};

export default BrowseListContainer;

interface BrowseListContainerOptions {
  products: ProductNode[];
  onScrollToEnd: () => void;
  isLoading: boolean;
  totalProducts: number;
  clearAllFilters: () => void;
  collectionHandle: string | undefined;
  collectionShopifyId: string;
  source: string;
  isPlp?: boolean;
  merchant?: string;
  hasNextPage: boolean;
}
